/** Goalkeeper is appended only when a compared player is a GK. */
export const OUTFIELD_CATEGORIES = [
    "Finishing",
    "Passing",
    "Defending",
    "Ball Control",
    "Physical",
];
/**
 * Whether a playstyle's raw category (from `playStylesDict`) belongs to a
 * display group. Finishing absorbs the backend's separate "Scoring" bucket —
 * mirrors `DetailedPlayStylesSection`.
 */
export const categoryMatches = (styleCategory, group) => group === "Finishing"
    ? styleCategory === "Scoring" || styleCategory === "Finishing"
    : styleCategory === group;
/** Ownership of a playstyle by a player: plus (gold) / normal (white) / none. */
export const playStyleState = (player, id) => ({
    hasPlus: player.playStylesPlus?.includes(id) ?? false,
    hasNormal: player.playStyles?.includes(id) ?? false,
});
/** True if any compared player is a goalkeeper (adds the Goalkeeper category). */
export const anyGoalkeeper = (players) => players.some((p) => p.preferredPosition === "GK");
/**
 * A category's playstyles that at least one compared player owns (plus or
 * base) — a playstyle nobody has says nothing in a comparison, so the row is
 * dropped and an empty category disappears entirely.
 */
export const ownedStyles = (styles, category, players) => styles
    .filter((style) => categoryMatches(style.category, category))
    .filter((style) => players.some((player) => {
    const { hasPlus, hasNormal } = playStyleState(player, style.id);
    return hasPlus || hasNormal;
}));
//# sourceMappingURL=playStyles.js.map